module.exports = __webpack_public_path__ + "img/210-grenada.11a3bd95.svg";